/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Checkbox } from '@pulsarml/ui.react.components';
import _ from 'lodash';
import React, { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { MachineOption } from 'types';
import { I18n } from '@utils/i18n';
import { sortMachines } from '../../utils/functions';
import styles from './index.module.scss';

interface MachinesContainerProps {
  onAllMachinesSelection: (
    options: (MachineOption & {
      machineGroupId: string;
    })[],
    remove: boolean
  ) => void;
  onMachinesSelection: (
    option: MachineOption & {
      machineGroupId: string;
    },
    removed: boolean
  ) => void;
  allMachineOptions: (MachineOption & {
    machineGroupId: string;
    order: number;
  })[];
  selectedMachines: (MachineOption & {
    machineGroupId: string;
    order: number;
  })[];
  selectedMachineGroupId: string;
  noOfUniqueSelectedMachines: number;
  'data-testid'?: string;
}
function MachinesContainer(props: MachinesContainerProps) {
  const machinesStore = useSelector((store: any) => store.machines);
  const machines: any[] = machinesStore.machines;
  const [searchTerm, setSearchTerm] = useState('');
  const selectAllOption = {
    label: I18n.t('select_all'),
    value: 'select-all'
  };

  const memoizedSortedMachines = React.useMemo(
    () =>
      sortMachines(
        props.selectedMachineGroupId !== 'all-machines'
          ? props.allMachineOptions
          : machines.map((e) => ({
              label: e.title,
              value: e.id,
              machineGroupId: 'all-machines',
              order: e.order
            }))
      ),
    [props.selectedMachineGroupId, props.allMachineOptions, machines]
  );

  const isAllMachinesSelected = React.useMemo(
    () =>
      memoizedSortedMachines?.filter((machine) =>
        machine.label.toLowerCase().includes(searchTerm.toLowerCase())
      )?.length ===
      _.uniqBy(props.selectedMachines, 'value').filter((machine) =>
        machine.label.toLowerCase().includes(searchTerm.toLowerCase())
      ).length,
    [memoizedSortedMachines, props.selectedMachines, searchTerm]
  );

  return (
    <div
      className={styles['machines-container']}
      data-testid={props['data-testid']}
    >
      <div className={styles['search-input-container']}>
        <span>
          <FiSearch color="#9d9d9d" size={20} />
        </span>
        <input
          className={styles['search-input']}
          placeholder={I18n.t('search_machine')}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
        />
      </div>
      <div className={styles['all-machine-rows']}>
        <div
          className={`${styles.selectAllCheckbox} ${styles.machineGroupCheckboxContainer}`}
          data-testid="select-all-machines-checkbox"
        >
          <Checkbox
            classNames={`flex-1 ${styles.machineGroupCheckbox}`}
            label={selectAllOption.label}
            checked={isAllMachinesSelected}
            onChange={() => {
              props.onAllMachinesSelection(
                memoizedSortedMachines?.filter((machine) =>
                  machine.label.toLowerCase().includes(searchTerm.toLowerCase())
                ) ?? [],
                isAllMachinesSelected
              );
            }}
          />
        </div>
        <div className={styles['machine-rows']} data-testid="machine-list">
          {memoizedSortedMachines
            ?.filter((machine) =>
              machine.label.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((option) => (
              <div
                className={styles.machineGroupCheckboxContainer}
                key={option.value}
              >
                <Checkbox
                  classNames={`flex-1 ${styles.machineGroupCheckbox}`}
                  label={option.label}
                  checked={props.selectedMachines
                    .map((curr) => curr.value)
                    .includes(option.value)}
                  onChange={() => {
                    props.onMachinesSelection(
                      option,
                      props.selectedMachines
                        .map((curr) => curr.value)
                        .includes(option.value)
                    );
                  }}
                  data-testid={`machine-checkbox-${option.value}`}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default MachinesContainer;
